import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { AbstractControl } from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
})
export class SelectorComponent implements OnInit, OnChanges {
  @Input() public label?: string;
  @Input() public remoteOperations = false;
  @ViewChild(DxSelectBoxComponent, { static: true })
  public dropDown?: DxSelectBoxComponent;
  @Input() public items: DataSource<any,any> = new DataSource<any,any>([]);
  @Input() public control: AbstractControl | null | undefined;
  @Input() public displayExpr: string = '';
  @Input() public keyExpr: string = '';
  @Input() public validationGroup: string = '';
  @Input() public required? = false;
  public selectedObject?: { id: number };

  public ngOnInit(): void {
    this.control?.valueChanges.subscribe((value) => {
      if (value === undefined || value === null) {
        this.dropDown?.instance.reset();
      } else {
        if (this.dropDown)
          if (typeof value === 'object') {
            this.dropDown.value = value[this.keyExpr];
          } else {
            this.dropDown.value = value;
          }
      }
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (!changes.items && this.dropDown) {
      this.dropDown.items = [];
      return;
    }
    if (
      changes.items.currentValue === null ||
      changes.items.currentValue === undefined
    ) {
      if (this.dropDown) this.dropDown.items = [];
    }
  }

  public selectionChange(e: any) {
    if (this.control && e.selectedItem && this.dropDown?.dataSource) {
      this.control.setValue(e.selectedItem);
    }
  }
}
